const Logo = () => (
    <img
        src="https://img.freepik.com/premium-vector/flat-web-template-with-lms-concept-design-concept-learning-management-system_100456-10755.jpg?"
        alt="LMS"
        width="100"
    />
);

export default Logo;
